import { Box, Button, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ResultsSection from './ResultsSection';
import ScenarioComparisonChart from './ScenarioComparisonChart';
import { SCENARIO_META, SCENARIO_ORDER } from './calc/scenarioMeta';

/**
 * Renders per-scenario results (P&L and the rest of the tables) with a scenario
 * switcher, followed by a metric-switchable comparison chart. When only the base
 * case ran it degrades to the plain single-scenario results view.
 */
function ScenarioResultsSection({
  scenarioMap,
  calcTimestamp,
  state,
  incomeExpanded,
  onToggleIncome,
  exposureGradeLimits,
  onDownloadExcel,
}) {
  const activeKeys = SCENARIO_ORDER.filter((key) => scenarioMap[key]);
  const [selected, setSelected] = useState('base');
  const current = scenarioMap[selected] ? selected : 'base';
  const hasComparison = activeKeys.length > 1;

  return (
    <Box>
      {hasComparison ? (
        <Flex align="center" gap={2} mb={3} flexWrap="wrap">
          <Text fontSize="sm" color="gray.500" mr={1}>
            View scenario:
          </Text>
          {activeKeys.map((key) => (
            <Button
              key={key}
              size="sm"
              variant={current === key ? 'solid' : 'outline'}
              colorScheme="purple"
              onClick={() => setSelected(key)}
            >
              {SCENARIO_META[key].label}
            </Button>
          ))}
        </Flex>
      ) : null}

      <ResultsSection
        key={current}
        calcResult={scenarioMap[current]}
        calcTimestamp={calcTimestamp}
        state={state}
        incomeExpanded={incomeExpanded}
        onToggleIncome={onToggleIncome}
        exposureGradeLimits={exposureGradeLimits}
        onDownloadExcel={onDownloadExcel}
      />

      {hasComparison ? (
        <ScenarioComparisonChart scenarioMap={scenarioMap} />
      ) : null}
    </Box>
  );
}

ScenarioResultsSection.propTypes = {
  scenarioMap: PropTypes.object.isRequired,
  calcTimestamp: PropTypes.instanceOf(Date),
  state: PropTypes.object.isRequired,
  incomeExpanded: PropTypes.bool.isRequired,
  onToggleIncome: PropTypes.func.isRequired,
  exposureGradeLimits: PropTypes.object,
  onDownloadExcel: PropTypes.func,
};

export default ScenarioResultsSection;
